import React from 'react';
import logoIFM from '../../assets/img/IFM.png';
import { Objetive } from './Components/Objetive';
import { CardToInstitutes } from "./Components/CardToInstitutes";
import { CardQuote } from '../../components/CardQuote';
import { Flow } from '../../workflows/Flow';
import { nodes, edges } from './matterFlow';

export function MinisterialTrainingInstitute() {
  return (
    <div className="container-fluid bg-light min-vh-100 pb-5">
      {/* --- Encabezado --- */}
      <header className="container py-5 text-center">
        <div className="mb-4">
          <img 
            src={logoIFM} 
            alt='Logo IFM' 
            className="img-fluid"
            style={{ maxWidth: '160px', filter: 'drop-shadow(0px 4px 6px rgba(0,0,0,0.1))' }} 
          />
        </div>
        <h1 className="display-4 fw-bold text-uppercase text-warning mb-3" style={{ color: '#f0ad4e' }}>
          Instituto de Formación Ministerial
        </h1>
        <p className="text-muted text-uppercase fw-bold ls-2">"Julio Vargas Bustamante"</p>
        <hr className="w-25 mx-auto border-warning border-2 opacity-75" />
      </header>

      <main className="container">
        {/* --- Quiénes Somos y Objetivo --- */}
        <section className="row g-4 mb-5">
          <div className="col-lg-6">
            <div className="bg-white p-4 rounded-4 shadow-sm h-100 border-top border-4 border-warning">
              <h3 className="h4 fw-bold mb-3 text-dark">¿Quiénes somos?</h3>
              <p className="text-secondary lh-lg">
                Es la institución educativa por excelencia de la <strong>ICIAR</strong> dedicada a la capacitación integral de los creyentes, 
                preparándolos espiritual y doctrinalmente para la edificación del cuerpo de Cristo.
              </p>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="bg-warning text-white p-4 rounded-4 shadow-sm h-100 d-flex align-items-center" style={{ backgroundColor: '#f0ad4e' }}>
              <Objetive objetive_info={'Capacitar a los creyentes en el desempeño de diferentes ministerios y formarlos conforme a Efesios 4:11-16.'}/>
            </div>
          </div>
        </section>

        {/* --- Visión, Misión y Organización --- */}
        <section className="row g-4 mb-5">
          <div className="col-md-4">
            <CardToInstitutes title={'Visión'} info={"México y las Naciones para Cristo."}/>
          </div>
          <div className="col-md-4">
            <CardToInstitutes title={'Misión'} info={"Formar miembros en plena comunión para ministerios de ayudas pastorales, instructores, evangelistas y administradores."}/>
          </div>
          <div className="col-md-4">
            <CardToInstitutes title={'Organización'} info={"Contamos con 24 materias distribuidas en 5 semestres, bajo áreas Académica, Técnica y Administrativa."}/>
          </div>
        </section>

        {/* --- Llamado y Reflexión --- */}
        <section className="mb-5">
          <div className="card border-0 rounded-5 overflow-hidden shadow-lg text-white">
            <div style={{
              background: 'linear-gradient(135deg, rgba(240, 173, 78, 0.95), rgba(255, 193, 7, 0.8))',
              position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, zIndex: 1
            }}></div>
            <div className="card-body p-5 text-center position-relative" style={{ zIndex: 2 }}>
              <h3 className="fw-bold mb-3">¿Has sentido el llamado de Dios para servir?</h3>
              <p className="lead mb-4 mx-auto fst-italic" style={{ maxWidth: '800px' }}>
                "La función de este Instituto desde 1982 es invaluable. Centenas de hermanos hoy son siervos fieles que contribuyen a la iglesia."
              </p>
              <div className="bg-white text-dark d-inline-block p-3 rounded-4 shadow-sm">
                <p className="mb-1 fw-bold">Jeremías 3:15</p>
                <small className="text-muted text-uppercase">Con ciencia e inteligencia</small>
              </div>
            </div>
          </div>
        </section>

        {/* --- Testimoniales --- */}
        <section className="mb-5">
          <h3 className="text-center fw-bold text-uppercase mb-4">Testimonios del IFM</h3>
          <div className="row g-4">
            <div className="col-md-6">
              <CardQuote 
                person={"Jaziel Isai"} 
                text="Llegué con ganas de mejorar en todos los ámbitos. Recibí apoyo y dirección de instructores que me ayudaron a que mi servicio a Dios sea el que Él demanda." 
              />
            </div>
            <div className="col-md-6">
              <CardQuote 
                person={"Norma Adareli"} 
                text="Doy gracias a Dios por estos medios. El consejo de los pastores fue propicio para mi formación y preparación constante." 
              />
            </div>
          </div>
        </section>

        {/* --- Mapa de Materias (Flow) --- */}
        <section className="mb-5 p-4 bg-white rounded-4 shadow-sm text-center">
          <h2 className="h4 fw-bold mb-4">MAPA CURRICULAR Y ESPECIALIDADES</h2>
          <div className="border rounded-3 overflow-hidden">
            <Flow 
              initialEdge={edges}
              initialNode={nodes}
              styleFlow={{ height: '30rem' }}
              disablePanOnDrag={false}
              disableZoomOnScroll={false} 
              disablePanOnScroll={true}
            />
          </div>
        </section>

        {/* --- Antecedentes Históricos (Timeline Style) --- */}
        <section className="p-4 bg-white rounded-4 shadow-sm">
          <h4 className="fw-bold border-bottom pb-3 mb-4">Breves Antecedentes Históricos</h4>
          <div className="row">
            <div className="col-md-4 text-center border-end d-none d-md-block">
                <div className="display-1 fw-bold text-warning opacity-25">1982</div>
                <p className="fw-bold">Año de Fundación</p>
            </div>
            <div className="col-md-8 lh-lg text-secondary">
              <p>Fundado por el <strong>Hno. Julio Vargas Bustamante</strong> en el templo “Monte de los Olivos”. A lo largo de los años, el instituto ha evolucionado en nombre y programa, adaptándose a las necesidades de la iglesia.</p>
              <p>En el 2005, se consolidó como un centro de especialidades en <strong>Ayuda Pastoral, Escuela Dominical, Evangelismo y Administración</strong>.</p>
              <p className="small bg-light p-3 rounded-3 mt-3">
                <strong>Sedes históricas:</strong> Monte de los Olivos (Escuadrón 201), Monte Sinaí (Culhuacán), Emanuel (Constitución de 1917) y su sede actual: <strong>Templo Bet-el (Col. Moctezuma)</strong>.
              </p>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
}